import { useEffect, useState } from "react";
import { AirSavedCardModel, airSavedCardStore, useSavedCardsQuery } from "entities/AirSavedCard";
import { AirSearchCardModel } from "entities/AirSearchCard";
import { authStore } from "entities/Auth";
import { useAppSelector } from "shared/lib/redux";

type UseAirOpenedCardIsFollowButtonVisibleProps = {
  openedCard: AirSavedCardModel | AirSearchCardModel | null;
};

export const useAirOpenedCardIsFollowButtonVisible = ({
  openedCard,
}: UseAirOpenedCardIsFollowButtonVisibleProps): { isAirFollowButtonVisible: boolean } => {
  const savedCards = useAppSelector(airSavedCardStore.selectors.savedCards);
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);

  const { getCards, cancelGetCardsRequest } = useSavedCardsQuery({ queryKey: ["openedCardIsFollowButtonVisible"] });

  const [isAirFollowButtonVisible, setIsAirFollowButtonVisible] = useState(false);

  useEffect(() => {
    const reference = openedCard?.reference;
    if (!reference || !isAuthenticated) return;

    const allCards = [...savedCards];

    if (allCards.length) {
      const isCardSaved = !!allCards.find((card) => card.reference === reference);
      setIsAirFollowButtonVisible(!isCardSaved);
      return;
    }

    getCards(
      { where: { reference } },
      {
        onSettled: (response) => {
          const isSavedCardFound = !!response?.length;
          setIsAirFollowButtonVisible(!isSavedCardFound);
        },
      }
    );

    return () => {
      cancelGetCardsRequest();
    };
  }, [savedCards.length, openedCard?.reference, isAuthenticated]);

  return { isAirFollowButtonVisible };
};
